import React, { FC } from 'react';
import { Input } from 'antd';
import BEMHelper from 'react-bem-helper';

import { ITextAreaProps } from './interfaces';

import './styles.scss';

const classes = new BEMHelper({
  name: 'text-area',
  outputIsString: true,
});

const TextArea: FC<ITextAreaProps> = ({
  className,
  rows = 4,
  error = false,
  value = '',
  onChange,
  ...otherProps
}) => {
  const { TextArea: AntdTextArea } = Input;

  return (
    <AntdTextArea
      {...otherProps}
      className={`${classes('', { error })} ${className || ''}`}
      rows={rows}
      value={value}
      onChange={onChange}
    />
  );
};

export default TextArea;
